import { HiChevronDown, HiOutlineFilter } from "react-icons/hi";
import { useEffect, useRef, useState } from "react";

const MultiSelectFilter = ({
    label,
    options = [],
    selectedValues = [],
    onChange,
    placeholder,
    loading = false,
}) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const handler = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    const toggleValue = (value) => {
        onChange(
            selectedValues.includes(value)
                ? selectedValues.filter(v => v !== value)
                : [...selectedValues, value]
        );
    };

    if (loading) {
        return <div className="w-56 h-10 bg-slate-100 rounded-lg animate-pulse" />;
    }

    return (
        <div ref={ref} className="relative w-56">
            <button
                onClick={() => setOpen(!open)}
                className="w-full h-10 flex items-center justify-between px-3 rounded-lg bg-slate-50 hover:bg-slate-100 transition"
            >
                <div className="flex items-center gap-2 text-sm text-slate-600">
                    <HiOutlineFilter className="text-slate-400" />
                    {selectedValues.length > 0
                        ? `${label} (${selectedValues.length})`
                        : placeholder}
                </div>
                <HiChevronDown
                    className={`transition-transform ${open ? "rotate-180" : ""}`}
                />
            </button>

            {open && (
                <div className="absolute z-50 mt-2 w-full bg-white rounded-lg shadow-lg max-h-60 overflow-auto">
                    {options.map(opt => (
                        <label
                            key={opt.value}
                            className="flex items-center gap-2 px-3 py-2 text-sm hover:bg-slate-50 cursor-pointer"
                        >
                            <input
                                type="checkbox"
                                checked={selectedValues.includes(opt.value)}
                                onChange={() => toggleValue(opt.value)}
                                className="accent-blue-600"
                            />
                            {opt.label}
                        </label>
                    ))}
                </div>
            )}
        </div>
    );
};

export default MultiSelectFilter;
